var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorPopsicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118.763,
    height: 105.941,
    viewBox: "0 0 118.763 105.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.169,
    y1: 0.821,
    x2: 0.892,
    y2: -0.429,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e2d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#f7dacf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#f3c6b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#eda58e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#e47858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc4f26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.004,
    y1: 0.944,
    x2: 0.937,
    y2: 0.331,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4754",
    "data-name": "Group 4754"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M202.172,9.827,173.8,40.556,163.12,30.013,193.21.832a2.955,2.955,0,0,1,4.13.019l4.73,4.657a3.1,3.1,0,0,1,.1,4.314Z",
    transform: "translate(-84.233 0)",
    fill: "#7f8585",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "d",
    transform: "translate(0.019 13.287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4752",
    "data-name": "Group 4752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M139.84,193.69c.092.048.189.092.285.135l.116-.116C140.111,193.7,139.971,193.695,139.84,193.69Z",
    transform: "translate(-72.231 -113.305)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M89.31,53.437c.488.532.759.851,1.054,1.146,4.362,4.362,8.71,8.734,13.1,13.077a3.913,3.913,0,0,1,1.253,3.023c-.039,7.622,0,15.244-.029,22.865a6.037,6.037,0,0,1-7.07,6.272c-2.984-.406-5.044-3.023-5.073-6.529-.024-3.023,0-6.05,0-9.073V82.71c-1.417,1.422-2.616,2.573-3.738,3.8-.218.232-.179.74-.184,1.127-.029,3.535.106,7.075-.111,10.6a5.877,5.877,0,0,1-5.644,5.726,6.061,6.061,0,0,1-6.219-4.662c-2.79,2.79-5.687,5.692-8.579,8.584-.131-.01-.271-.015-.4-.019.092.048.189.092.285.135l.116-.116c.271.019.546.029.822.034,3.414.044,6.843-.077,10.243.16a5.816,5.816,0,0,1,5.412,6.026,6.076,6.076,0,0,1-5.707,5.953c-.508.044-1.02.029-1.528.029-23.064,0-46.127-.048-69.191.048-3.8.015-6.674-.967-8.076-4.739V112.8c.764-2.171,1.983-3.937,4.338-4.551a10.54,10.54,0,0,1,2.553-.3c3.027-.039,6.055-.014,9.077-.019.377,0,.75-.039,1.286-.063-.653-.919-1.248-1.683-1.765-2.5-7.423-11.723-5.948-25.81,3.879-35.7q20.479-20.616,41.083-41.1c1.461-1.461,2.394-1.451,3.888.044q6.551,6.536,13.082,13.082c.3.3.571.648.953,1.083L89.32,53.442Z",
    transform: "translate(-0.04 -27.474)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g",
    transform: "translate(0 13.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4753",
    "data-name": "Group 4753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M89.285,53.445c.488.532.759.851,1.054,1.146,4.357,4.362,8.71,8.739,13.1,13.072a3.923,3.923,0,0,1,1.253,3.027c-.039,7.622,0,15.244-.029,22.865a6.035,6.035,0,0,1-7.075,6.268C94.6,99.418,92.54,96.8,92.511,93.3c-.029-3.023,0-6.05,0-9.073V82.718c-1.412,1.417-2.616,2.573-3.738,3.8-.213.232-.174.74-.179,1.122-.034,3.535.1,7.08-.111,10.6a5.88,5.88,0,0,1-5.649,5.721A6.059,6.059,0,0,1,76.609,99.3c-2.829,2.829-5.765,5.765-8.7,8.7l-.285-.135c.406.019.817.048,1.224.053,3.414.039,6.843-.077,10.243.16a5.808,5.808,0,0,1,5.412,6.021,6.073,6.073,0,0,1-5.707,5.953c-.508.044-1.02.029-1.533.029-23.064,0-46.127-.044-69.191.048-3.8.015-6.669-.962-8.076-4.739v-2.592c.759-2.171,1.978-3.932,4.338-4.551a10.555,10.555,0,0,1,2.558-.31c3.023-.034,6.05-.015,9.077-.015.372,0,.75-.034,1.286-.063-.653-.919-1.248-1.683-1.76-2.5-7.423-11.723-5.948-25.81,3.879-35.7Q39.857,49.052,60.461,28.568c1.465-1.465,2.394-1.451,3.888.044Q70.9,35.148,77.436,41.7c.3.3.571.648.953,1.083L89.294,53.46Zm-26.9-21.008a3.828,3.828,0,0,0-.319.256C48.676,46.08,35.212,59.4,21.917,72.886a23.68,23.68,0,0,0-3.289,29.752,47.139,47.139,0,0,0,4.812,5.765c.624.721,1.011,1.586.488,2.35a5.2,5.2,0,0,1-1.949,1.262c-.251.131-.619.024-.933.024H7.022c-1.983,0-2.911.6-2.965,1.905-.053,1.344.948,2.041,2.965,2.041H77.514a6.78,6.78,0,0,0,1.4-.111,1.761,1.761,0,0,0,1.494-1.843,1.82,1.82,0,0,0-1.548-1.934,5.743,5.743,0,0,0-1.291-.058q-7.3,0-14.615,0a2.3,2.3,0,0,1-2.428-1.291c-.464-1.078.063-1.867.8-2.607q7.639-7.61,15.258-15.244c.721-.725,1.461-1.33,2.587-.885,1.161.459,1.32,1.431,1.335,2.505.015,1.257,0,2.515.111,3.763a1.676,1.676,0,0,0,1.654,1.552,1.815,1.815,0,0,0,2.041-1.243,3.6,3.6,0,0,0,.135-1.277c.01-3.535.024-7.07,0-10.606a3.65,3.65,0,0,1,1.146-2.834c2.394-2.331,4.739-4.706,7.09-7.08.73-.74,1.509-1.311,2.6-.875a2.327,2.327,0,0,1,1.354,2.505q-.015,6.014,0,12.023c0,1.18-.029,2.36.029,3.535a1.927,1.927,0,0,0,3.835.179,8.234,8.234,0,0,0,.082-1.291c0-7.032-.01-14.063.024-21.1a2.644,2.644,0,0,0-.861-2.055Q81.465,51.489,63.228,33.23c-.271-.271-.556-.532-.837-.8Z",
    transform: "translate(0 -27.48)",
    fill: "#ee7d62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M38.98,132.844a20.189,20.189,0,0,1,5.823-14.1c2.331-2.389,4.706-4.735,7.075-7.09,1.064-1.054,2.244-1.156,3.114-.324.924.88.832,2.07-.28,3.2-2.558,2.607-5.233,5.107-7.675,7.82a15.964,15.964,0,0,0,.164,21.274c.106.116.218.227.319.348,1.045,1.214,1.078,2.384.1,3.211-.933.793-2.08.624-3.1-.474a20.235,20.235,0,0,1-5.547-13.87Z",
    transform: "translate(-20.124 -70.492)",
    fill: "#ee7d62"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPopsicle);
export default __webpack_public_path__ + "static/media/error-popsicle.9792c99a90b35343564174d659b2cc58.svg";
export { ForwardRef as ReactComponent };